// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3wIVy","buttons":"Footer_buttons__2Y4kK"};